(ns quuppa.qsm.permissions-access)
;; This namespace is for future possible functions to control resource permissions both for client and backend
(defn get-user-role [user]
  (first (:roles user)))

(def user-roles
  [{:value "quuppa-support"
    :text "Quuppa Support"}
   {:value "owner"
    :text "Owner"}
   {:value "admin"
    :text "Admin"}
   {:value "member"
    :text "Member"}])

(def roles-levels
  [{:role "quuppa-support"
    :level 4}
   {:role "owner"
    :level 3}
   {:role "admin"
    :level 2}
   {:role "member"
    :level 1}])

(defn get-role-level [role]
  (->> roles-levels
       (filter (fn [role-level]
                 (= role (:role role-level))))
       (first)
       :level))

(defn qsm-user-roles-options [current-user-role]
  (->> user-roles
       (remove (fn [role]
                 (some #{(:value role)} ["quuppa-support", "member"])))
       (filter (fn [role]
                 (>= (get-role-level current-user-role)
                     (get-role-level (:value role)))))))

(defn user-roles-options [current-user-role]
  (->> user-roles
       (remove (fn [role]
                 (= (:value role) "quuppa-support")))
       (filter (fn [role]
                 (>= (get-role-level current-user-role)
                     (get-role-level (:value role)))))))
